import type { AdminStaffProfile, AdminStaffProfilesResponse } from '@oracord/shared';
import { apiFetch } from './api';

export async function fetchStaffProfiles(): Promise<AdminStaffProfile[]> {
  const res = await apiFetch<AdminStaffProfilesResponse>('/api/admin/staff');
  return res.rows;
}
